import React, { useEffect, useState, useMemo } from "react";
import axios from "axios";
import "./DDReport.css";
import { Link, useNavigate } from "react-router-dom";
import { fetchUserProfile } from "../../redux/slices/branch/userProfileSlice";
import { useSelector, useDispatch } from "react-redux";
import { FaRupeeSign } from "react-icons/fa";


const secondaryTabs = ["All", "Active", "Closed","Pending","Matured", "Pre-Closed", "Reject"];
const rowsPerPage = 10;

const RDReport = () => {
  const navigate = useNavigate();
   const dispatch = useDispatch();

  const [activeMainTab, setActiveMainTab] = useState("RD");
  const [activeSecondary, setActiveSecondary] = useState("All");
  const [searchQuery, setSearchQuery] = useState("");
  const [accounts, setAccounts] = useState([]);
  const [loading, setLoading] = useState(false);
  const { profile } = useSelector((state) => state.userProfile);
  const [frequency, setFrequency] = useState("All");
  

  const [currentPage, setCurrentPage] = useState(1);
  // const [totalPages, setTotalPages] = useState(1);


const handleViewEmi = (account) => {
  navigate(`/Deposit/EmiDetails/${account.id}`, { state: { account } });
};



  useEffect(() => {
    dispatch(fetchUserProfile());
  }, [dispatch]);


  // Fetch Accounts
  const fetchAccounts = async () => {  
    try {
      setLoading(true);
      const superAdminId = profile.superAdminId || 14;
      const branchId = localStorage.getItem("userId") || 56;

      const res = await axios.get("https://payyug.in/api/deposit/list", {
        params: {
          superAdminId,
          branchId,
          page: currentPage,
          limit: rowsPerPage,
          accountType: activeMainTab,
          status: activeSecondary !== "All" ? activeSecondary : undefined,
          // search: searchQuery || undefined,
        },
      });

      console.log("deposit list:",res)
      if (res.data.success) {
        setAccounts(res.data.data || []);
        // setTotalPages(res.data.totalPages || 1);
      } else {
        setAccounts([]);
      }
    } catch (err) {
      console.error("Error fetching deposit accounts:", err);
      setAccounts([]);
    } finally {
      setLoading(false);
    }
  };

  // useEffect(() => {
  //   fetchAccounts();
  // }, [activeMainTab, activeSecondary, searchQuery, currentPage]);
 
  useEffect(() => {
    if (profile?.superAdminId) {
      fetchAccounts();
    }
  }, [activeMainTab, activeSecondary, profile]);


  useEffect(() => {
    setCurrentPage(1);
  }, [activeMainTab, activeSecondary,searchQuery,frequency]);

  const filteredAccounts = useMemo(() => {
    let data = [...accounts];

    if (searchQuery.trim() !== "") {
        const query = searchQuery.toLowerCase();

        data = data.filter(
          (acc) =>
            acc.accountNo?.toLowerCase().includes(query) ||
            acc.customerName?.toLowerCase().includes(query)
        );
      }

    // 🔹 STATUS FILTER
    if (activeSecondary !== "All") {
      data = data.filter(
        (acc) =>
          acc.status?.toLowerCase() === activeSecondary.toLowerCase()
      );
    }

    // 🔹 FREQUENCY FILTER
    if (frequency !== "All") {
      data = data.filter(
        (acc) =>
          acc.installmentFrequency?.toLowerCase() ===
          frequency.toLowerCase()
      );
    }

    return data;
  }, [accounts, activeSecondary, frequency, searchQuery]);
  
   const totalPages = filteredAccounts.length
    ? Math.ceil(filteredAccounts.length / rowsPerPage)
    : 0;

  const paginatedAccounts = useMemo(() => {
    const start = (currentPage - 1) * rowsPerPage;
    const end = start + rowsPerPage;
    return filteredAccounts.slice(start, end);
  }, [filteredAccounts, currentPage]);
  // // Render Table Rows
  // const renderTable = useMemo(() => {
  //   if (loading) {
  //     return (
  //       <tr>
  //         <td colSpan="11" style={{ textAlign: "center" }}>
  //           Loading...
  //         </td>
  //       </tr>
  //     );
  //   }

  //   if (!accounts.length) {
  //     return (
  //       <tr>
  //         <td colSpan="11" style={{ textAlign: "center" }}>
  //           No Data Found
  //         </td>
  //       </tr>
  //     );
  //   }

  //   return accounts.map((acc, index) => (
  //     <tr key={acc.id}>
  //       {/* SN */}
  //       <td>{(currentPage - 1) * rowsPerPage + index + 1}</td>

  //       {/* Account No */}
  //       <td>{acc.accountNo}</td>

  //       {/* Customer Name */}
  //       <td>{acc.customerName || "--"}</td>

  //       {/* Account Type */}
  //       <td>{acc.accountType || "--"}</td>
  //       <td>{acc.schemeName || "--"}</td>
  //       <td>{acc.installmentFrequency || "--"}</td>

  //       {/* ROI */}
  //       <td>{acc.roi || "--"}%</td>

  //       {/* Installment Amount */}
  //       <td>₹{acc.amount?.toLocaleString() || 0}</td>

  //       {/* Tenure */}
  //       <td>{acc.tenure || "--"}</td>

  //       {/* Principal Amount */}
  //       <td>₹{acc.principalAmount?.toLocaleString() || "--"}</td>

  //       {/* Refer ID */}
  //       {/* <td>{acc.referralId || "--"}</td> */}

  //       {/* Nominee ID */}
  //       {/* <td>{acc.nomineeCusId || "--"}</td> */}

  //       {/* RD Cirtificate */}
  //       <td><Link to={"/Banking/Report/RDCertificates"} className="rd-cirtificate-open-btn" state={{ row: acc }}>Open</Link></td>

  //       {/* Action */}
  //       <td>
  //         <button
  //           className="DDFDReportview-btn"
  //   onClick={() => handleViewEmi(acc)}
  //         >
  //           View
  //         </button>
  //       </td>
  //     </tr>
  //   ));
  // }, [accounts, loading, currentPage]);

  const renderTable = useMemo(() => {
  if (loading) {
    return (
      <tr>
        <td colSpan="13" style={{ textAlign: "center" }}>Loading...</td>
      </tr>
    );
  }

  if (!paginatedAccounts.length){
    return (
      <tr>
        <td colSpan="13" style={{ textAlign: "center" }}>No Data Found</td>
      </tr>
    );
  }

  return paginatedAccounts.map((acc, index) => {
    const isPending = acc.status === "Pending";

    return (
      <tr key={acc.id}>
        {/* SN */}
        <td>{(currentPage - 1) * rowsPerPage + index + 1}</td>

        {/* Account No */}
        <td>{acc.accountNo}</td>

        {/* Customer Name */}
        <td>{acc.customerName || "--"}</td>

        {/* Account Type */}
        <td>{acc.accountType || "--"}</td>

        {/* Scheme */}
        <td>{acc.schemeName || "--"}</td>

        {/* Frequency */}
        <td>{acc.installmentFrequency || "--"}</td>

        {/* ROI */}
        <td>{acc.roi || "--"}%</td>

        {/* Installment Amount */}
        <td>₹{acc.amount?.toLocaleString() || 0}</td>

        {/* Tenure */}
        <td>{acc.tenure || "--"}</td>

        {/* Principal Amount */}
        <td>₹{acc.principalAmount?.toLocaleString() || "--"}</td>

        {/* Passbook */}
        <td>
          <Link to={"/Banking/Report/RDDDPassbook"} state={{row:acc}} className="rd-cirtificate-open-btn">Open</Link>
        </td>

        {/* RD Certificate */}
        <td>
          {isPending ? (
           <span className="status-badge-not-approved">Not Approved</span>
          ) : (
            <Link
              to={"/Banking/Report/RDCertificates"}
              className="rd-cirtificate-open-btn"
              state={{ row: acc }}
            >
              Open
            </Link>
          )}
        </td>
        {/* Refer ID */}
        {/* <td>{acc.referralId || "--"}</td> */}

        {/* Nominee ID */}
        {/* <td>{acc.nomineeCusId || "--"}</td> */}

        {/* RD Cirtificate */}
        {/* <td><Link to={"/Banking/Report/RDCertificates"} className="rd-cirtificate-open-btn" state={{ row: acc }}>Open</Link></td> */}
        {/* <td><Link to={"/Banking/Report/Membership"} className="rd-cirtificate-open-btn" state={{ row: acc }}>Open</Link></td> */}

        {/* Action */}
        <td>
          {isPending ? (
            <span className="status-badge-not-approved">Not Approved</span>

          ) : (
            <button
              className="DDFDReportview-btn"
              onClick={() => handleViewEmi(acc)}
            >
              <FaRupeeSign />

            </button>
          )}
        </td>
      </tr>
    );
  });
}, [paginatedAccounts, loading, currentPage]);

  return (
    <div className="DDFDReport-container">
      <h2 style={{ textAlign: "center", marginBottom: 10 }}>
        {activeMainTab} Account Report
      </h2>

      {/* Main Tabs */}
      <div className="DDFDReport-main-tabs">
        {["RD", "DD"].map((tab) => (
          <button
            key={tab}
            className={`DDFDReport-main-btn ${
              activeMainTab === tab ? "active" : ""
            }`}
            onClick={() => setActiveMainTab(tab)}
          >
            {tab} Report
          </button>
        ))}
      </div>

      {/* Secondary Tabs */}
      <div className="DDFDReport-secondary-tabs">
        {secondaryTabs.map((tab) => (
          <button
            key={tab}
            className={`DDFDReport-secondary-btn ${
              activeSecondary === tab ? "active" : ""
            }`}
            onClick={() => setActiveSecondary(tab)}
          >
            {tab}
          </button>
        ))}

         <div className="dropdown-filter ">
          <select
            value={frequency}
            onChange={(e) => setFrequency(e.target.value)}
          >
          <option value="All">All</option>
          <option value="Daily">Daily</option>
          <option value="Weekly">Weekly</option>
          <option value="Monthly">Monthly</option>
        </select>
      </div>
      </div>

      {/* Search */}
      <div className="DDFDReportsearch-box">
        <input
          type="text"
          placeholder="Search by Account No / Customer..."
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
        />
      </div>

      {/* Table */}
      <div className="DDFDReporttable-container">
        <table className="DDFDReport-table">
          <thead>
            <tr>
              <th>SN</th>
              <th>Account No</th>
              <th>Customer Name</th>
              <th>Account Type</th>
              <th>scheme Name</th>
              <th>installment Frequency</th>
              <th>ROI</th>
              <th>Installment Amount</th>
              <th>Tenure</th>
              <th>Principal Amount</th>
              <th>Passbook</th>
              <th>Certificate</th>
              {/* <th>MemberShip Form</th> */}
              {/* <th>Refer ID</th>
              <th>Nominee ID</th> */}
              <th>Action</th>
            </tr>
          </thead>
          <tbody>{renderTable}</tbody>
        </table>
      </div>

      {/* Pagination */}
      <div className="DDFDReportpagination">
        <button
          disabled={currentPage === 1}
          onClick={() => setCurrentPage((p) => p - 1)}
        >
          Previous
        </button>

        <span>
          Page {currentPage} of {totalPages}
        </span>

        <button
          disabled={currentPage >= totalPages}
          onClick={() => setCurrentPage((p) => p + 1)}
        >
          Next
        </button>
      </div>
    </div>
  );
};

export default RDReport;
